module.exports = __webpack_public_path__ + "static/media/03-2.a2071cc6.webp";